/**
 * artikelleichen — Root-App-Shell (Plan 02-05). Anders als das Vorbild-Programm hat
 * dieses Programm in Phase 2 nur EINE Seite (die Warnliste) — kein Router noetig.
 */
import WarnlistePage from './pages/WarnlistePage';

export default function ArtikelleichenApp() {
  return <WarnlistePage />;
}
